import React, { Component } from 'react';
import { preloader } from '../../utils/animation';
import styles from './styles.scss';

class TermsAndConditions extends Component {
  componentDidMount() {
    preloader().play();

    if (document && document.body) {
      document.body.classList.add('technicians');
    }
  }

  componentWillUnmount() {
    if (document && document.body) {
      document.body.classList.remove('technicians');
    }
  }

  showPDF = link => {
    window.open(link);
  };

  render() {
    return (
      <div className={styles.content}>
        <h1>Rent from us - Forms & Policies</h1>
        <ol className={styles.linksList}>
          <li>
            <span onClick={() => this.showPDF('//api.centerstaging.us/assets/files/CS_NewCustomerForm.pdf')}>
              New Customer Form
            </span>
          </li>
          <li>
            <span onClick={() => this.showPDF('//api.centerstaging.us/assets/files/CS_CreditCardAuthorization.pdf')}>
              Credit Card Form Authorization Form
            </span>
          </li>
          <li>
            <span onClick={() => this.showPDF('//api.centerstaging.us/assets/files/CS_InsuranceRequirements.pdf')}>
              Insurance Requirements Form
            </span>
          </li>
          <li>
            <span onClick={() => this.showPDF('//api.centerstaging.us/assets/files/InsuranceCertificateSample.pdf')}>
              Insurance Sample Page
            </span>
          </li>
          <li>
            <span onClick={() => this.showPDF('//api.centerstaging.us/assets/files/CS_Terms-Conditions2015.pdf')}>
              Rental Terms and Conditions
            </span>
          </li>
          <li>
            <span onClick={() => this.showPDF('//api.centerstaging.us/assets/files/CS_CreditApp.pdf')}>
              Credit Application for Net 30 Terms
            </span>
          </li>
          <li>
            <span onClick={() => this.showPDF('//api.centerstaging.us/assets/files/W9NY.pdf')}>
              W-9 CenterStaging NY, LLC
            </span>
          </li>
          <li>
            <span onClick={() => this.showPDF('//api.centerstaging.us/assets/files/W9.pdf')}>
              W-9 CenterStaging, LLC - Burbank, CA
            </span>
          </li>
          <li>
            <span onClick={() => this.showPDF('//api.centerstaging.us/assets/files/590.pdf')}>
              590 - Withholding Exemption Certificate
            </span>
          </li>
        </ol>
        <h1>Web Site Terms and Conditions of Use</h1>
        <ol>
          <li>
            <span>1. Terms</span>
            <p>
              By accessing this web site, you are agreeing to be bound by these web site Terms and Conditions of Use,
              all applicable laws and regulations, and agree that you are responsible for compliance with any applicable
              local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this
              site. The materials contained in this web site are protected by applicable copyright and trade mark law.
            </p>
          </li>
          <li>
            <span>2. Use License</span>

            <p className={styles.wrapIndent}>
              <span>A.</span>
              <span className={styles.indent}>
                Permission is granted to temporarily download one copy of the materials (information or software) on
                CenterStaging, LLC.'s web site for personal, non-commercial transitory viewing only. This is the grant
                of a license, not a transfer of title, and under this license you may not:
              </span>
            </p>

            <p>
              <ul>
                <li>● modify or copy the materials;</li>
                <li>
                  ● use the materials for any commercial purpose, or for any public display (commercial or
                  non-commercial);
                </li>
                <li>
                  ● attempt to decompile or reverse engineer any software contained on CenterStaging, LLC.'s web site;
                </li>
                <li>● remove any copyright or other proprietary notations from the materials;</li>
                <li>● or transfer the materials to another person or "mirror" the materials on any other server.</li>
              </ul>
            </p>

            <p className={styles.wrapIndent}>
              <span>B.</span>
              <span className={styles.indent}>
                This license shall automatically terminate if you violate any of these restrictions and may be
                terminated by CenterStaging, LLC. at any time. Upon terminating your viewing of these materials or upon
                the termination of this license, you must destroy any downloaded materials in your possession whether in
                electronic or printed format.
              </span>
            </p>
          </li>
          <li>
            <span>3. Disclaimer</span>
            <p>
              The materials on CenterStaging, LLC.'s web site are provided "as is". CenterStaging, LLC. makes no
              warranties, expressed or implied, and hereby disclaims and negates all other warranties, including without
              limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or
              non-infringement of intellectual property or other violation of rights. Further, CenterStaging, LLC. does
              not warrant or make any representations concerning the accuracy, likely results, or reliability of the use
              of the materials on its Internet web site or otherwise relating to such materials or on any sites linked
              to this site.
            </p>
          </li>
          <li>
            <span>4. Limitations</span>
            <p>
              In no event shall CenterStaging, LLC. or its suppliers be liable for any damages (including, without
              limitation, damages for loss of data or profit, or due to business interruption,) arising out of the use
              or inability to use the materials on CenterStaging, LLC.'s Internet site, even if CenterStaging, LLC. or a
              CenterStaging, LLC. authorized representative has been notified orally or in writing of the possibility of
              such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of
              liability for consequential or incidental damages, these limitations may not apply to you.
            </p>
          </li>
          <li>
            <span>5. Revisions and Errata</span>
            <p>
              The materials appearing on CenterStaging, LLC.'s web site could include technical, typographical, or
              photographic errors. CenterStaging, LLC. does not warrant that any of the materials on its web site are
              accurate, complete, or current. CenterStaging, LLC. may make changes to the materials contained on its web
              site at any time without notice. CenterStaging, LLC. does not, however, make any commitment to update the
              materials.
            </p>
          </li>
          <li>
            <span>6. Links</span>
            <p>
              CenterStaging, LLC. has not reviewed all of the sites linked to its Internet web site and is not
              responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement
              by CenterStaging, LLC. of the site. Use of any such linked web site is at the user's own risk.
            </p>
          </li>
          <li>
            <span>7. Site Terms of Use Modifications</span>
            <p>
              CenterStaging, LLC. may revise these terms of use for its web site at any time without notice. By using
              this web site you are agreeing to be bound by the then current version of these Terms and Conditions of
              Use.
            </p>
          </li>
          <li>
            <span>8. Governing Law</span>
            <p>
              Any claim relating to CenterStaging, LLC.'s web site shall be governed by the laws of the State of
              California without regard to its conflict of law provisions. General Terms and Conditions applicable to
              Use of a Web Site.
            </p>
          </li>
        </ol>
        <h1>Privacy Policy</h1>
        <p>
          Your privacy is very important to us. Accordingly, we have developed this Policy in order for you to
          understand how we collect, use, communicate and disclose and make use of personal information. The following
          outlines our privacy policy.
        </p>
        <ul className={styles.privacy}>
          <li>
            ● Before or at the time of collecting personal information, we will identify the purposes for which
            information is being collected.
          </li>
          <li>
            ● We will collect and use of personal information solely with the objective of fulfilling those purposes
            specified by us and for other compatible purposes, unless we obtain the consent of the individual concerned
            or as required by law.
          </li>
          <li>
            ● We will only retain personal information as long as necessary for the fulfillment of those purposes.
          </li>
          <li>
            ● We will collect personal information by lawful and fair means and, where appropriate, with the knowledge
            or consent of the individual concerned.
          </li>
          <li>
            ● Personal data should be relevant to the purposes for which it is to be used, and, to the extent necessary
            for those purposes, should be accurate, complete, and up-to-date.
          </li>
          <li>
            ● We will protect personal information by reasonable security safeguards against loss or theft, as well as
            unauthorized access, disclosure, copying, use or modification.
          </li>
          <li>
            ● We will make readily available to customers information about our policies and practices relating to the
            management of personal information.
          </li>
        </ul>
        We are committed to conducting our business in accordance with these principles in order to ensure that the
        confidentiality of personal information is protected and maintained.
      </div>
    );
  }
}

export default TermsAndConditions;



// WEBPACK FOOTER //
// ./src/pages/TermsAndConditions/index.js